<template>
  <div>
    <user-reg-lp v-if="isLaunchpack"></user-reg-lp>
    <user-reg v-else></user-reg>
  </div>
</template>
<script>
  import UserReg from "./UserReg";
  import UserRegLp from "./UserRegLp";
  export default {
    name: 'UserRegBase',
    components: {UserRegLp, UserReg}
  }
</script>
